import type {BuildId} from '../../../../../types'
import type {SeqProps} from '../../../../common/SequenceLoader/SequenceLoader.types'

export enum VcsRootGroup {
  DEPENDENCIES = 'dependencies',
  SETTINGS = 'settings',
}

export type Props = SeqProps & {
  className?: string
  buildId: BuildId
}

export type RequestBuildChangesRevisionsParams = {
  withSettingsRevisions?: boolean
}
